// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Accessibility: keyboard focus and contrast
 * Adds visible focus indicators and high-contrast focus ring only.
 * No changes to existing logic or visual styles; additive only.
 */

/* High-contrast focus ring (WCAG 2.1 AA): visible on light and dark backgrounds */
:root {
  --ts-focus-ring-color: #b2ccf2;
  --ts-focus-ring-color-inverse: #64b5f6;
  --ts-focus-ring-width: 2px;
  --ts-focus-ring-offset: 2px;
}

/* Keyboard-focusable: visible focus ring for all focusable elements (additive only) */
a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
[tabindex]:not([tabindex="-1"]):focus-visible,
[role="button"]:focus-visible,
[role="link"]:focus-visible,
[role="menuitem"]:focus-visible,
[role="tab"]:focus-visible,
[role="option"]:focus-visible,
[contenteditable="true"]:focus-visible,
summary:focus-visible {
  outline: var(--ts-focus-ring-width) solid var(--ts-focus-ring-color);
  outline-offset: var(--ts-focus-ring-offset);
}

/* MUI / Bootstrap: ensure focus-visible uses our high-contrast ring when they use :focus */
.MuiButton-root:focus-visible,
.MuiIconButton-root:focus-visible,
.MuiTab-root:focus-visible,
.MuiListItem-button:focus-visible,
.MuiMenuItem-root:focus-visible,
.btn:focus-visible,
.form-control:focus-visible,
.form-select:focus-visible,
.input-group .form-control:focus-visible,
.dropdown-toggle:focus-visible {
  outline: var(--ts-focus-ring-width) solid var(--ts-focus-ring-color);
  outline-offset: var(--ts-focus-ring-offset);
}

/* Clickable icons and controls: export, language selector, help, table actions, dropdown items */
.cursor-pointer:focus-visible,
.dropdown-item:focus-visible,
.language-selector-wrapper label:focus-visible,
.notifications-pic:focus-visible,
.profile-pic:focus-visible,
.action-icon-button:focus-visible,
.nav-link:focus-visible,
[class*="IconButton"]:focus-visible {
  outline: var(--ts-focus-ring-width) solid var(--ts-focus-ring-color);
  outline-offset: var(--ts-focus-ring-offset);
}

/* Dark backgrounds: use lighter focus ring for contrast (optional, additive) */
@media (prefers-color-scheme: dark) {
  .bg-dark:focus-visible,
  [data-theme="dark"] a:focus-visible,
  [data-theme="dark"] button:focus-visible,
  [data-theme="dark"] input:focus-visible,
  [data-theme="dark"] select:focus-visible,
  [data-theme="dark"] textarea:focus-visible,
  [data-theme="dark"] [tabindex]:not([tabindex="-1"]):focus-visible {
    outline-color: var(--ts-focus-ring-color-inverse);
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/accessibility.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,kFAAkF;AAClF;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,sFAAsF;AACtF;;;;;;;;;;;;;EAaE,oEAAoE;EACpE,2CAA2C;AAC7C;;AAEA,2FAA2F;AAC3F;;;;;;;;;;EAUE,oEAAoE;EACpE,2CAA2C;AAC7C;;AAEA,iGAAiG;AACjG;;;;;;;;EAQE,oEAAoE;EACpE,2CAA2C;AAC7C;;AAEA,+EAA+E;AAC/E;EACE;;;;;;;IAOE,iDAAiD;EACnD;AACF","sourcesContent":["/**\n * Accessibility: keyboard focus and contrast\n * Adds visible focus indicators and high-contrast focus ring only.\n * No changes to existing logic or visual styles; additive only.\n */\n\n/* High-contrast focus ring (WCAG 2.1 AA): visible on light and dark backgrounds */\n:root {\n  --ts-focus-ring-color: #b2ccf2;\n  --ts-focus-ring-color-inverse: #64b5f6;\n  --ts-focus-ring-width: 2px;\n  --ts-focus-ring-offset: 2px;\n}\n\n/* Keyboard-focusable: visible focus ring for all focusable elements (additive only) */\na:focus-visible,\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible,\n[tabindex]:not([tabindex=\"-1\"]):focus-visible,\n[role=\"button\"]:focus-visible,\n[role=\"link\"]:focus-visible,\n[role=\"menuitem\"]:focus-visible,\n[role=\"tab\"]:focus-visible,\n[role=\"option\"]:focus-visible,\n[contenteditable=\"true\"]:focus-visible,\nsummary:focus-visible {\n  outline: var(--ts-focus-ring-width) solid var(--ts-focus-ring-color);\n  outline-offset: var(--ts-focus-ring-offset);\n}\n\n/* MUI / Bootstrap: ensure focus-visible uses our high-contrast ring when they use :focus */\n.MuiButton-root:focus-visible,\n.MuiIconButton-root:focus-visible,\n.MuiTab-root:focus-visible,\n.MuiListItem-button:focus-visible,\n.MuiMenuItem-root:focus-visible,\n.btn:focus-visible,\n.form-control:focus-visible,\n.form-select:focus-visible,\n.input-group .form-control:focus-visible,\n.dropdown-toggle:focus-visible {\n  outline: var(--ts-focus-ring-width) solid var(--ts-focus-ring-color);\n  outline-offset: var(--ts-focus-ring-offset);\n}\n\n/* Clickable icons and controls: export, language selector, help, table actions, dropdown items */\n.cursor-pointer:focus-visible,\n.dropdown-item:focus-visible,\n.language-selector-wrapper label:focus-visible,\n.notifications-pic:focus-visible,\n.profile-pic:focus-visible,\n.action-icon-button:focus-visible,\n.nav-link:focus-visible,\n[class*=\"IconButton\"]:focus-visible {\n  outline: var(--ts-focus-ring-width) solid var(--ts-focus-ring-color);\n  outline-offset: var(--ts-focus-ring-offset);\n}\n\n/* Dark backgrounds: use lighter focus ring for contrast (optional, additive) */\n@media (prefers-color-scheme: dark) {\n  .bg-dark:focus-visible,\n  [data-theme=\"dark\"] a:focus-visible,\n  [data-theme=\"dark\"] button:focus-visible,\n  [data-theme=\"dark\"] input:focus-visible,\n  [data-theme=\"dark\"] select:focus-visible,\n  [data-theme=\"dark\"] textarea:focus-visible,\n  [data-theme=\"dark\"] [tabindex]:not([tabindex=\"-1\"]):focus-visible {\n    outline-color: var(--ts-focus-ring-color-inverse);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
